export const isMapAvailable = async (mapSrc: string) => {
	try {
		const response = await fetch(mapSrc);

		return response.ok;
	} catch {
		return false;
	}
};
